import { Image } from 'antd';
import styled from 'styled-components';

export const Title = styled.div`
  color: #525252;
  font-size: 24px;
  font-weight: 700;
`;

export const Description = styled.div`
  color: #525252;
  font-size: 16px;
  font-weight: 400;
  padding-top: 4px;
  margin-bottom: 24px;
`;

export const CustomImage = styled(Image)`
  border-radius: 8px;
`;

export const Body = styled.div``;
